// Pure Logik für das Checkout-Übernahme-Banner (App -> Web-Checkout).
//
// Das Banner spiegelt die aus der mobilen App per ?paket=/?land= übergebene
// Auswahl wider. Wichtig: Sobald der Nutzer im Web etwas ändert (anderes Land)
// oder die Übernahme bewusst verwirft ("Auswahl ändern"), darf das Banner keine
// veraltete/falsche Auswahl mehr behaupten. Diese reine Logik wird aus
// `web/src/pages/Packages.tsx` heraus verwendet und ist getestet
// (`web/src/lib/__tests__/checkoutHandoff.test.ts`), damit der Schutz nicht
// stillschweigend wieder verloren geht.

export const HANDOFF_HEADING_FROM_APP = "Deine Auswahl aus der App";
export const HANDOFF_HEADING_CURRENT = "Deine aktuelle Auswahl";

// Hat der Nutzer das Basis-Land seit der App-Übernahme bewusst geändert?
// Nur dann ist die Bezeichnung „aus der App" nicht mehr korrekt.
export function isHandoffCountryChanged(
  handoffLand: string | null,
  baseCountry: string,
): boolean {
  return Boolean(handoffLand && baseCountry && baseCountry !== handoffLand);
}

// Überschrift des Banners: nach einer Änderung neutral „aktuelle Auswahl",
// sonst weiterhin „aus der App".
export function handoffBannerHeading(countryChanged: boolean): string {
  return countryChanged ? HANDOFF_HEADING_CURRENT : HANDOFF_HEADING_FROM_APP;
}

// Weicht das im Web gewählte Paket vom App-Handoff (?paket=) ab? Nur dann ist
// das Übernahme-Banner veraltet und muss verworfen werden, sonst behauptet es
// kurz vor der Zahlung noch das alte Paket. Gibt es keinen App-Handoff
// (handoffPackageId leer) oder ist das gewählte Paket unbekannt, gilt das nicht
// als Abweichung.
export function isHandoffPackageMismatch(
  handoffPackageId: string | null,
  selectedPackageId: string | null | undefined,
): boolean {
  return Boolean(
    handoffPackageId && selectedPackageId && selectedPackageId !== handoffPackageId,
  );
}

// Wird das Banner überhaupt angezeigt? Nur wenn die App eine Auswahl mitgegeben
// hat (Paket oder Land) UND der Nutzer sie nicht verworfen hat.
export function showHandoffBanner(opts: {
  hasHandoffPackage: boolean;
  hasHandoffCountry: boolean;
  dismissed: boolean;
}): boolean {
  return Boolean(opts.hasHandoffPackage || opts.hasHandoffCountry) && !opts.dismissed;
}
